import type { CrmRole } from "@school-sales-ai/shared";

type Props = { role: CrmRole };

export function RoleBadge({ role }: Props): React.JSX.Element {
  if (role === "super_admin") {
    return (
      <span className="rounded-full bg-[oklch(0.92_0.05_300)] px-2.5 py-0.5 text-xs font-semibold text-[oklch(0.30_0.14_300)]">
        Super Admin
      </span>
    );
  }
  if (role === "account_manager") {
    return (
      <span className="rounded-full bg-[oklch(0.92_0.05_155)] px-2.5 py-0.5 text-xs font-semibold text-[oklch(0.30_0.12_155)]">
        Account Manager
      </span>
    );
  }
  if (role === "admin") {
    return (
      <span className="rounded-full bg-[oklch(0.92_0.05_255)] px-2.5 py-0.5 text-xs font-semibold text-[oklch(0.28_0.12_255)]">
        Admin
      </span>
    );
  }
  return (
    <span className="rounded-full border border-ink-100 bg-ink-100 px-2.5 py-0.5 text-xs font-semibold text-ink-500">
      Miembro
    </span>
  );
}
